import { MenuItem } from "@mui/material";
import { Link } from "react-router-dom";
import Iconify from "src/components/Iconify";
import Translate from "src/components/translate";
import useImpersonate from "src/hooks/useImpersonate";
import { PATH_DASHBOARD } from "src/routes/paths";

const RetailActions = ({ selectedId }) => {
  const onImpersonate = useImpersonate(selectedId);

  return (
    <>
      <MenuItem
        onClick={onImpersonate}
        sx={{ color: "default.main" }}
        name="impersonate"
      >
        <Iconify icon={"ant-design:user-switch-outlined"} />
        <Translate>network_members.impersonate</Translate>
      </MenuItem>

      <MenuItem
        component={Link}
        to={`${PATH_DASHBOARD.members.member_profile}/${selectedId}`}
        sx={{ color: "default.main" }}
        name="profile"
      >
        <Iconify icon={"ant-design:user-outlined"} />
        <Translate>network_members.profile</Translate>
      </MenuItem>
    </>
  );
};

export default RetailActions;
